import './fonts/fontfaces.css';

export default {
  lato: 'Lato',
  lora: 'Lora',
};
